export enum FinApiErrorCode {
  NAME_MISMATCH = 'NAME_MISMATCH',
  DEFAULT = 'DEFAULT',
}

export const errorCodeToTranslationKey: Record<string, string> = {
  [FinApiErrorCode.NAME_MISMATCH]: 'errors.finapi.name.mismatch',
  [FinApiErrorCode.DEFAULT]: 'VerificationLandingPage.errorMessage',
};

export const getErrorTranslationKey = (errorReason: FinApiErrorCode | null | undefined): string => {
  if (!errorReason) return errorCodeToTranslationKey.DEFAULT;
  return errorCodeToTranslationKey[errorReason] || errorCodeToTranslationKey.DEFAULT;
};

export type FinApiStatus = {
  isVerified: boolean;
  errorReason: FinApiErrorCode | null;
};
